import React, { forwardRef } from "react"
import { Box, Button, Typography, useTheme } from "@mui/material"
import { ChevronDownIcon } from "../../../../../mp-core/icons"
import { useStyles } from "./styles"

type Props = {
  id: string
  links: any
  pageName: string
  disabled?: boolean
}

const TriggerButton = forwardRef<HTMLButtonElement, Props>(
  ({ id, links, pageName, disabled = false, ...rest }, ref) => {
    const { classes } = useStyles()
    const theme = useTheme()

    const pageModule = links.products?.find(
      (item: Record<string, any>) => item.name === pageName
    )

    const pageModuleName = pageModule ? pageModule.children?.[0]?.name : ""

    const buttonText = (
      <Box flexShrink={1} className={classes.buttonSelectProductBox}>
        {!pageModule?.hideChildName && pageModuleName ? (
          <Typography
            className={classes.typographyButtonSelect}
            variant="subtitle1"
            align="left"
          >
            {pageName}
          </Typography>
        ) : null}
        <Typography variant="h6" align="left">
          {!pageModule?.hideChildName ? pageModuleName || pageName : pageName}
        </Typography>
      </Box>
    )

    return (
      <Button
        disableRipple
        id={id}
        size="large"
        ref={ref}
        className={classes.mainButton}
        endIcon={
          !disabled && (
            <ChevronDownIcon
              style={{
                fontSize: "0.6875rem",
                marginLeft: theme.spacing(4)
              }}
            />
          )
        }
        disabled={disabled}
        data-automation-id="products-dropdown"
        {...rest}
      >
        {buttonText}
      </Button>
    )
  }
)

export default TriggerButton
